import styled from 'styled-components';

export const TitleBold = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #161d1f;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #161d1f;
  line-height: 20px;
`;

export const TextLI = styled.li`
  font-size: 14px;
  font-weight: 400;
  color: #161d1f;
  line-height: 20px;
  margin-left: 8px;
  margin-right: 16px;
  white-space: pre-wrap;
  list-style-position: inside;
  padding-left: 20px;
  text-indent: -20px;
`;

export const MessageInfo = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  padding: 16px;
  border-radius: 4px;
  background-color: #d5e5f0;
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  column-gap: 8px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;

  @media (640px <= width <= 767.5px) {
    height: 72px;
  }

  @media (max-width: 639.5px) {
    height: 92px;
  }
`;

export const ImgMessageInfo = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const TitleFooter = styled.h1`
  width: fit-content;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;
`;

export const ContainerFooter = styled.div<{
  isMobile: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: ${(prop) => (prop.isMobile ? '16px' : '8px')};
  background: #ecf4f9;
`;

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 8px;
  background: #ffffff;
`;
